import { CookieBar } from "./components/CookieBar";
initSociosGlobals({ infoText: 'FV' });
import { DomSelectorUtils } from "./libs/utils/DomSelectorUtils";
import { vp, VPSubs } from "./managers/vp";
import { TopSlider } from "./components/sliders/TopSlider";
import { TopHeader } from "./components/TopHeader";
import { SideMenu } from "./components/SideMenu";
import { ListSlider } from "./components/sliders/ListSlider";
import { NavList } from "./components/NavList";
import { NavListItem } from "./components/NavListItem";
import { ArticleMediaItem } from "./components/ArticleMediaItem";
import { GridList } from "./components/sliders/GridList";
import { MediaItemComponent } from "./components/MediaItemComponent";
import { SearchField } from "./components/SearchField";
import { ChunkLoader } from "./components/ChunkLoader";
import { initSociosGlobals } from "socios-tools/utils/Globals";
import { DomUtils } from "socios-tools/utils/DomUtils";
import "../css/main.scss";
window.isMobile = require("ismobilejs");
DomUtils.onDomReady().then(() => {
    vp.queue.push(window.s_queue);
    vp.domReady();
    vp.components.pushQueue('MediaItemComponent', MediaItemComponent);
    vp.components.pushQueue('TopHeader', TopHeader);
    vp.components.pushQueue('SideMenu', SideMenu);
    vp.components.pushQueue('NavListItem', NavListItem);
    vp.components.pushQueue('NavList', NavList);
    vp.components.pushQueue('TopSlider', TopSlider);
    vp.components.pushQueue('ArticleMediaItem', ArticleMediaItem);
    vp.components.pushQueue('GridList', GridList);
    vp.components.pushQueue('CookieBar', CookieBar);
    vp.components.pushQueue('SearchField', SearchField);
    vp.components.pushQueue('ChunkLoader', ChunkLoader);
    vp.queue.push(() => {
        const html = document.getElementsByTagName('html')[0];
        html.setAttribute('data-is-touch', vp.isTouchDevice() ? 'true' : 'false');
    });
    vp.queue.push(() => {
        vp.topicManager.init();
        vp.topicManager.listenToHashChange();
    });
    let listSliderHtmls = DomSelectorUtils.getHtmlList('ListSlider', document.body);
    function checkListSliders() {
        if (listSliderHtmls.length > 0) {
            listSliderHtmls = listSliderHtmls.filter((htmlElement) => {
                if (DomUtils.inView(htmlElement)) {
                    vp.queue.push(() => {
                        if (!vp.components.getByHTML(htmlElement)) {
                            vp.components.addComponent(new ListSlider(htmlElement));
                        }
                    });
                    return false;
                }
                else {
                    return true;
                }
            });
        }
    }
    checkListSliders();
    window.addEventListener('resize', () => {
        vp.loadImagesInView();
    });
    window.addEventListener('beforeunload', () => {
        vp.components.forEach({ jsName: 'NavList' }, (navList) => {
            vp.localStorageData.menu.scroll = navList.scrollTop;
        });
    });
    vp.components.forEach({ jsName: 'NavList' }, (navList) => {
        navList.scrollTop = vp.localStorageData.menu.scroll;
    });
    vp.listener.subscribe((sub) => {
        switch (sub) {
            case VPSubs.onDocumentScrollSteps:
            case VPSubs.onWindowResizeSteps:
                vp.loadImagesInView();
                checkListSliders();
                break;
        }
    });
    vp.queue.push(() => {
        vp.components.forEach(null, (component) => {
            component.onAllComplete();
        });
    });
    function getTopAdsTagsFromAllMediaItems(filterPercentage) {
        const totalPerTag = {};
        let totalItems = 0;
        vp.components.forEach({ jsName: 'MediaItemComponent' }, (item) => {
            item.data.advertisingTargeting.forEach((tag) => {
                totalPerTag[tag] = totalPerTag[tag] ? totalPerTag[tag] + 1 : 1;
            });
            totalItems += 1;
        }, true);
        logger.dir(totalPerTag);
        let topTag = '';
        for (let tag in totalPerTag) {
            if (!topTag || totalPerTag[tag] > totalPerTag[topTag]) {
                topTag = tag;
            }
        }
        return topTag;
    }
    function onImagesComplete() {
        vp.queue.push(() => {
            let tags = [];
            if (window.__data_topic && window.__data_topic.meta && window.__data_topic.meta.advertising_targeting) {
                tags = tags.concat(window.__data_topic.meta.advertising_targeting);
            }
            if (vp.pageType === 'topic') {
                if (tags.length === 0) {
                    logger.log('---------');
                    tags.push(getTopAdsTagsFromAllMediaItems(.8));
                    logger.dir(tags);
                }
            }
            if (vp.pageType === 'item') {
                let found = false;
                vp.components.forEach({ jsName: 'Article' }, (article) => {
                    found = true;
                    article.init().then(() => {
                        tags = tags.concat(article.videoModel.advertisingTargeting);
                        vp.loadLazy(tags);
                    });
                });
                if (!found) {
                    vp.loadLazy(tags);
                }
            }
            else {
                vp.loadLazy(tags);
            }
        });
    }
    vp.queue.push(() => {
        setTimeout(() => {
            vp.loadImagesInView(onImagesComplete);
        }, 100);
    });
    vp.queue.push(() => {
        vp.startDOMListeners();
    });
}).catch((e) => {
    logger.error(e);
});
